import { render, staticRenderFns } from "./ItemYelpReview.vue?vue&type=template&id=3dcd2f9a"
import script from "./ItemYelpReview.vue?vue&type=script&lang=js"
export * from "./ItemYelpReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports